import { createGlobalStyle } from 'styled-components/macro'
import { mq } from './mq'
import { theme } from './theme'
import BackgroundImage from './assets/bg-dark.png'

export const GlobalStyle = createGlobalStyle`
:root {
  --text-color: ${theme.colors.text};
  --background-color: ${theme.colors.background};
  --background: ${theme.colors.background} url(${BackgroundImage}) 0 0 repeat;
  --theme-color: ${theme.colors.text};
  --header-height: 5.7rem;
  --header-height: calc(env(safe-area-inset-top) + 5.7rem);
  --grid-size: ${(24 / 280) * 100}%;
  --gap-size: ${(5 / 280) * 100}%;
  --container-spacing: ${(20 / 320) * 100}%;
  --container-width: calc(12 * var(--grid-size) + 11 * var(--gap-size));
}

${mq.medium} {
  :root {
    --container-spacing: ${(4 / 140) * 100}%;
    --grid-size: ${(9 / 132.8) * 100}%;
    --gap-size: ${(2 / 132.8) * 100}%;
    --header-height: 6.4rem;
  }
}

${mq.large} {
  :root {
    --container-spacing: 5rem;
    --grid-size: 8.85rem;
    --gap-size: 2rem;
  }
}

html {
  height: 100%;
  font-size: 62.5%;
  overflow-x: hidden;
  ${mq.large} {
    overflow-x: visible;
  }
}

body {
  margin: 0;
  overflow-x: hidden;
  font-family: ${theme.fonts.base},
    sans-serif;
  min-height: 100%;
  width: 100%;
  font-size: 1.6rem;
  font-smooth: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;
  -webkit-tap-highlight-color: transparent;
  color: var(--text-color);
  background: var(--background);
  /* scroll-behavior: smooth; */

  ${mq.medium} {
    font-size: 1.8rem;
  }

  ${mq.large} {
    font-size: 2rem;
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}

body.locked {
  overflow: hidden;
}

#root {
  display: contents;

  > * {
    flex-shrink: 0;
  }
}

a {
  color: ${theme.colors.accent.primary};
  text-decoration: none;
}

.underline a {
  border-bottom: 1px solid ${theme.colors.accent.primary};
}
`
